let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2bwO4")).then(() => parcelRequire('ipuf7'));